// 7.2.2 IsArray(argument)
var cof = require('./$.cof');
module.exports = Array.isArray || function(arg){
  return cof(arg) == 'Array';
};


//////////////////
// WEBPACK FOOTER
// C:/wamp/www/node_modules/core-js/library/modules/$.is-array.js
// module id = 241
// module chunks = 0